import produce from 'immer';

import { GET_OTP_CODE_FAILURE, GET_OTP_CODE_START, GET_OTP_CODE_SUCCESS } from '@redux/actions/campaignRegister/getOtpCode/types';

const initialState = {
  isLoading: false,
  getOtpCodeResult: null,
  error: null
};

const getOtpCodeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
    case GET_OTP_CODE_START:
      draft.isLoading = true;

      draft.error = null;
      break;

    case GET_OTP_CODE_SUCCESS:
      draft.isLoading = false;

      draft.getOtpCodeResult = action.payload;
      break;

    case GET_OTP_CODE_FAILURE:
      draft.isLoading = false;

      draft.error = action.payload;
      break;
    }

    return draft;
  });

export default getOtpCodeReducer;
